// extracted by mini-css-extract-plugin
export default {"categories-container":"Categories_categories-container__FRmOO"};